import { dataPersistence } from './dataPersistence'

export interface ExtractedData {
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  address?: {
    street?: string
    city?: string
    state?: string
    zipCode?: string
  }
  dateOfBirth?: string
  ssn?: string
  propertyAddress?: {
    street?: string
    city?: string
    state?: string
    zipCode?: string
  }
  [key: string]: any
}

export const documentExtraction = {
  simulateExtraction: async (file: File, documentType: 'id' | 'property' | 'closing' | 'other'): Promise<ExtractedData> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const cached = dataPersistence.getAll()
        let extracted: ExtractedData = {}
        
        if (documentType === 'id') {
          extracted = {
            firstName: cached.firstName || 'John',
            lastName: cached.lastName || 'Doe',
            dateOfBirth: cached.dateOfBirth || '1980-01-15',
            address: cached.address || {
              street: '123 Main St',
              city: 'Los Angeles',
              state: 'CA',
              zipCode: '90001'
            }
          }
        } else if (documentType === 'property') {
          extracted = {
            propertyAddress: cached.propertyAddress || {
              street: '456 Oak Avenue',
              city: 'Beverly Hills',
              state: 'CA',
              zipCode: '90210'
            }
          }
        } else if (documentType === 'closing') {
          extracted = {
            firstName: cached.firstName || 'John',
            lastName: cached.lastName || 'Doe',
            email: cached.email || 'john.doe@example.com',
            phone: cached.phone || '(555) 123-4567',
            address: cached.address || {
              street: '123 Main St',
              city: 'Los Angeles',
              state: 'CA',
              zipCode: '90001'
            }
          }
        }
        
        dataPersistence.merge(extracted)
        resolve(extracted)
      }, 2000)
    })
  },

  extractFromPDF: async (file: File): Promise<ExtractedData> => {
    return documentExtraction.simulateExtraction(file, 'other')
  }
}

